import { arenaLogic } from './arena.logic';

import { ArenaHostView, ArenaProjectorView, ArenaStudentView } from './ArenaViews';

import type { ActivityPlugin } from '../../core/types/activity.types';

import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';



export const arenaPlugin: ActivityPlugin<'arena'> = {

  ...arenaLogic,

  displayName: GAME_MODE_CATALOG.arena.displayName,

  icon: GAME_MODE_CATALOG.arena.icon,

  HostView: ArenaHostView,

  StudentView: ArenaStudentView,

  ProjectorView: ArenaProjectorView,

};



export { demoArenaPayload } from './arena.logic';

